<template>
  <div class="filters">
    <div id="aaa">
      <!-- 个人信息 -->
      <div class="personInfoBox">
        <el-collapse @change="handleChange">
          <el-collapse-item title="个人情况:（可点击查看此项说明）" name="1">
            <div>填写本人的基本信息</div>
          </el-collapse-item>
        </el-collapse>
        <div class="topBox">
          <span class="mr10 c-676a6c">部门</span>
          <el-select :disabled="isDisabled" v-model="formData.orgDepartmentId" filterable placeholder="请选择部门">
            <el-option v-for="item in sectionOptions" :key="item.id" :label="item.deptName" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="topBox">
          <span class="mr10 c-676a6c">职务</span>
          <el-select :disabled="isDisabled" v-model="formData.orgJobId" filterable placeholder="请选择职务">
            <el-option v-for="item in jobOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="topBox">
          <span class="mr10 c-676a6c">直接主管</span>
          <el-select :disabled="isDisabled" v-model="formData.orgLeaderId" filterable placeholder="请选择直接主管">
            <el-option v-for="item in leaderOptions" :key="item.id" :label="item.idNo" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <p class="mtb10  c-676a6c">换岗经历</p>
        <el-input :disabled="isDisabled" type="textarea" :rows="4" placeholder="换岗经历"
          v-model="formData.changeJobExperience">
        </el-input>
      </div>
      <!-- 工作结果及自评 -->
      <div class="workResults">
        <el-collapse @change="handleChange">
          <el-collapse-item title="工作结果及自评:（可点击查看此项说明）" name="2">
            <div>回顾上一阶段你参与的最重要的3-5个工作/任务（如设有既定发展计划的将作为其中一项主要工作），说明完成上述工作/任务的标志或你和直接上级达成的共同期望是什么。
              对比标志或期望评估目前的现状如何。用远远超过、超过、达到、部分达到、没达到来表示。针既定发展计划，用已完成、部分完成、未完成来表示。
              根据员工日常表现进行评估。员工与直接上级都要以事实说话，通过积极交流，双方对评估观点、意见、结果达成共识。</div>
          </el-collapse-item>
        </el-collapse>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="工作总结1" name="summary1">
            <p class="mtb10  c-676a6c">最重要的工作/任务</p>
            <el-input :disabled="isDisabled" type="textarea" :rows="3" placeholder="最重要的工作/任务"
              v-model="formData.majorWork1">
            </el-input>
            <div class="evaluateBoxs">
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">客户满意度</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue1_1" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">进度</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue1_2" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">质量</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue1_3" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">数量</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue1_4" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">费用</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue1_5" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="工作总结2" name="summary2">
            <p class="mtb10  c-676a6c">最重要的工作/任务</p>
            <el-input :disabled="isDisabled" type="textarea" :rows="3" placeholder="最重要的工作/任务"
              v-model="formData.majorWork2">
            </el-input>
            <div class="evaluateBoxs">
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">客户满意度</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue2_1" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">进度</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue2_2" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">质量</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue2_3" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">数量</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue2_4" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">费用</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue2_5" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="工作总结3" name="summary3">
            <p class="mtb10  c-676a6c">最重要的工作/任务</p>
            <el-input :disabled="isDisabled" type="textarea" :rows="3" placeholder="最重要的工作/任务"
              v-model="formData.majorWork3">
            </el-input>
            <div class="evaluateBoxs">
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">客户满意度</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue3_1" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">进度</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue3_2" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">质量</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue3_3" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">数量</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue3_4" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">费用</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue3_5" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="工作总结4" name="summary4">
            <p class="mtb10  c-676a6c">最重要的工作/任务</p>
            <el-input :disabled="isDisabled" type="textarea" :rows="3" placeholder="最重要的工作/任务"
              v-model="formData.majorWork4">
            </el-input>
            <div class="evaluateBoxs">
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">客户满意度</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue4_1" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">进度</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue4_2" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">质量</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue4_3" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">数量</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue4_4" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">费用</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue4_5" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="工作总结5" name="summary5">
            <p class="mtb10  c-676a6c">最重要的工作/任务</p>
            <el-input :disabled="isDisabled" type="textarea" :rows="3" placeholder="最重要的工作/任务"
              v-model="formData.majorWork5">
            </el-input>
            <div class="evaluateBoxs">
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">客户满意度</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue5_1" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">进度</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue5_2" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">质量</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue5_3" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">数量</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue5_4" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="evaluateBox">
                <span class="mr10 c-676a6c w-100">费用</span>
                <el-select :disabled="isDisabled" v-model="formData.evaluateValue5_5" filterable placeholder="自我审评">
                  <el-option v-for="item in evaluateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-tab-pane>

        </el-tabs>
      </div>
      <!-- 改进及发展计划 -->
      <div class="improvementPlan">
        <el-collapse @change="handleChange">
          <el-collapse-item title="改进及发展计划:（可点击查看此项说明）" name="3">
            <div>根据评估结果和客户/上级/同事/供应商对不足之处的反馈。 重点应放在可能对提高未来工作绩效影响最大的少数需改进地方（素质能力、专业技能等）。
              明确直接上级及员工个人为支持员工专业发展和职业兴趣将采取的具体的行动及时间计划。改进不足要与其下一步工作相联系，没有适合的工作，
              员工的不足不可能光凭注意就能发展起来。发展的愿望和责任在于员工，直接上级的作用是辅佐、支持、成为导师。</div>
          </el-collapse-item>
          <div class="textareaBox">
            <div class="textareaBox3">
              <p class="mtb10 c-676a6c">现有长处所在</p>
              <el-input :disabled="isDisabled" type="textarea" :rows="4" placeholder="现有长处所在"
                v-model="formData.nowAdvantage">
              </el-input>
            </div>
            <div class="textareaBox3">
              <p class="mtb10 c-676a6c">提高新的高度/水平是什么</p>
              <el-input :disabled="isDisabled" type="textarea" :rows="4" placeholder="提高新的高度/水平是什么"
                v-model="formData.promote">
              </el-input>
            </div>
            <div class="textareaBox3">
              <p class="mtb10 c-676a6c">采取的行动计划</p>
              <el-input :disabled="isDisabled" type="textarea" :rows="4" placeholder="采取的行动计划"
                v-model="formData.actionPlanForPromote">
              </el-input>
            </div>
            <div class="textareaBox3">
              <p class="mtb10 c-676a6c">需要改进方面</p>
              <el-input :disabled="isDisabled" type="textarea" :rows="4" placeholder="需要改进方面"
                v-model="formData.improvement">
              </el-input>
            </div>
            <div class="textareaBox3">
              <p class="mtb10 c-676a6c">改进的目标</p>
              <el-input :disabled="isDisabled" type="textarea" :rows="4" placeholder="改进的目标"
                v-model="formData.improvementGoal">
              </el-input>
            </div>
            <div class="textareaBox3">
              <p class="mtb10 c-676a6c">采取的行动计划</p>
              <el-input :disabled="isDisabled" type="textarea" :rows="4" placeholder="采取的行动计划"
                v-model="formData.actionPlanForImprovement">
              </el-input>
            </div>
          </div>
        </el-collapse>
      </div>
      <!-- 职业发展兴趣 -->
      <div class="improvementPlan">
        <el-collapse @change="handleChange">
          <el-collapse-item title="职业发展兴趣:（可点击查看此项说明）" name="4">
            <div>这一回顾有助于计划好员工个人与公司业务的一致性。但这不是个合同。员工的实际进展将取决于员工个人发展及公司业务需要。 上级的评论，不视为承诺，再上级要知道并在适当的时候给予指导评论</div>
          </el-collapse-item>
          <div class="textareaBox">
            <div class="textareaBox2">
              <p class="mtb10 c-676a6c">个人短期职业兴趣（1-2年）</p>
              <el-input :disabled="isDisabled" type="textarea" :rows="4" placeholder="个人短期职业兴趣（1-2年）"
                v-model="formData.personalShortCareerInterest">
              </el-input>
            </div>
            <div class="textareaBox2">
              <p class="mtb10 c-676a6c">个人长期职业兴趣（5年左右）</p>
              <el-input :disabled="isDisabled" type="textarea" :rows="4" placeholder="个人长期职业兴趣（5年左右）"
                v-model="formData.personalLongCareerInterest">
              </el-input>
            </div>
            <div class="textareaBox1">
              <p class="mtb10 c-676a6c">工作地点的灵活度(请在下列地点中选择)：SOHO，繁荣里，康泉府，馨港湾，自由成，阳光城，喜鹊，木棉花一期，常青藤，生活坊一期，
                生活坊二期，生活坊三期，生活坊四期，生活坊五期，玫瑰湾（一期），豪森，春晓，梦夏（可填写多个）</p>
              <el-input :disabled="isDisabled" type="textarea" :rows="4" placeholder="工作地点的灵活度"
                v-model="formData.flexibilityWorkplace">
              </el-input>
            </div>
          </div>
        </el-collapse>
      </div>
      <el-button class="btn-first" type="primary" @click="onSave">保存</el-button>
      <el-button class="detailbtn" type="primary" @click="onSubmit">提交</el-button>
      <p class="c-676a6c">（保存：保存本页信息，可更改。 提交：提交给相关负责人，不可更改！ ）</p>
    </div>
  </div>
</template>
<script>
  import {
    mapGetters
  } from 'vuex'
  export default {
    data() {
      return {
        id: '',
        state: 1,
        userName: '',
        isDisabled: false, //是否不可编辑
        sectionOptions: [], //部门list
        jobOptions: [{
          value: 1,
          label: '经理'
        }, {
          value: 2,
          label: '主管'
        }, {
          value: 3,
          label: '专员'
        }], //职务list
        leaderOptions: [], //直接主管list
        evaluateOptions: [{
          value: 1,
          label: '远远超过'
        }, {
          value: 2,
          label: '超过'
        }, {
          value: 3,
          label: '达到'
        }, {
          value: 4,
          label: '部分达到'
        }, {
          value: 5,
          label: '没达到'
        }], //自我审批list
        activeName: 'summary1', //工作总结默认tab
        formData: {
          orgDepartmentId: '', //选择的部门值
          orgJobId: '', //选择的职务值
          orgLeaderId: '', //选择的直接主管值
          changeJobExperience: '', //换岗经历

          majorWork1: '', //重要工作、任务1
          majorWork2: '', //重要工作、任务2
          majorWork3: '', //重要工作、任务3
          majorWork4: '', //重要工作、任务4
          majorWork5: '', //重要工作、任务5

          evaluateValue1_1: '', //工作总结1-客户满意度
          evaluateValue1_2: '', //工作总结1-进度
          evaluateValue1_3: '', //工作总结1-质量
          evaluateValue1_4: '', //工作总结1-数量
          evaluateValue1_5: '', //工作总结1-费用

          evaluateValue2_1: '', //工作总结2-客户满意度
          evaluateValue2_2: '', //工作总结2-进度
          evaluateValue2_3: '', //工作总结2-质量
          evaluateValue2_4: '', //工作总结2-数量
          evaluateValue2_5: '', //工作总结2-费用

          evaluateValue3_1: '', //工作总结3-客户满意度
          evaluateValue3_2: '', //工作总结3-进度
          evaluateValue3_3: '', //工作总结3-质量
          evaluateValue3_4: '', //工作总结3-数量
          evaluateValue3_5: '', //工作总结3-费用

          evaluateValue4_1: '', //工作总结4-客户满意度
          evaluateValue4_2: '', //工作总结4-进度
          evaluateValue4_3: '', //工作总结4-质量
          evaluateValue4_4: '', //工作总结4-数量
          evaluateValue4_5: '', //工作总结4-费用

          evaluateValue5_1: '', //工作总结5-客户满意度
          evaluateValue5_2: '', //工作总结5-进度
          evaluateValue5_3: '', //工作总结5-质量
          evaluateValue5_4: '', //工作总结5-数量
          evaluateValue5_5: '', //工作总结5-费用

          nowAdvantage: '', //现有长处所在
          promote: '', //提高新的高度/水平是什么
          actionPlanForPromote: '', //采取的行动计划
          improvement: '', //需要改进方面
          improvementGoal: '', //改进的目标
          actionPlanForImprovement: '', //采取的行动计划

          personalShortCareerInterest: '', //短期兴趣
          personalLongCareerInterest: '', //长期兴趣
          flexibilityWorkplace: '', //工作地点

          importantTaskIdList: [],
          workSummaryList: []
        }

      }
    },
    computed: {
      ...mapGetters({
        staffId: 'staffId',
        gardenId: 'gardenId'
      })
    },
    methods: {
      handleChange(val) {
        console.log(val);
      },
      handleClick(tab, event) {
        console.log(tab.index);
      },
      // 获取部门下拉数据
      getSectionOptions() {
        this.$get(`getOrgDepartmentListByPid/0?pageNo=1&pageSize=9999`).then(
          res => {
            if (res && res.errCode === 0) {
              this.sectionOptions = res.list
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 获取直接主管下拉数据
      getEvaluateOptions() {
        this.$get(`staffs?gardenId=9&pageNo=1&pageSize=9999`).then(
          res => {
            if (res && res.errCode === 0) {
              this.leaderOptions = res.list
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 获取保存数据
      getEmpAssessmentForm() {
        this.$get(`getEmpAssessmentForm?staffId=${this.staffId}`).then(
          res => {
            if (res && res.errCode === 0) {
              console.log(res)
              let empAssessmentData = res.empAssessmentForm
              if (empAssessmentData != null) {
                if (empAssessmentData.state != 1) {
                  this.isDisabled = true
                } else {
                  this.isDisabled = false
                }
                this.id = empAssessmentData.id
                this.state = empAssessmentData.state
                this.userName = empAssessmentData.userName
                this.formData.orgDepartmentId = empAssessmentData.orgDepartmentId ? empAssessmentData
                  .orgDepartmentId : ''
                this.formData.orgJobId = empAssessmentData.orgJobId ? empAssessmentData.orgJobId : ''
                this.formData.orgLeaderId = empAssessmentData.orgLeaderId ? empAssessmentData.orgLeaderId : ''
                this.formData.actionPlanForImprovement = empAssessmentData.actionPlanForImprovement
                this.formData.actionPlanForPromote = empAssessmentData.actionPlanForPromote
                this.formData.changeJobExperience = empAssessmentData.changeJobExperience
                this.formData.flexibilityWorkplace = empAssessmentData.flexibilityWorkplace
                this.formData.improvement = empAssessmentData.improvement
                this.formData.improvementGoal = empAssessmentData.improvementGoal
                this.formData.nowAdvantage = empAssessmentData.nowAdvantage
                this.formData.personalLongCareerInterest = empAssessmentData.personalLongCareerInterest
                this.formData.personalShortCareerInterest = empAssessmentData.personalShortCareerInterest
                this.formData.promote = empAssessmentData.promote

                this.formData.workSummaryList = res.workSummaryList
                // if (res.workSummaryList.length > 0) {
                //   for (let i = 0; i < res.workSummaryList.length; i++) {
                //     this.formData.importantTaskIdList.push(res.workSummaryList[i].importantTaskId)
                //   }
                //   console.log(this.formData.importantTaskIdList)
                // }

              }
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 保存
      onSave() {
        let arr = []
        let obj1 = {}
        let obj2 = {}
        let obj3 = {}
        let obj4 = {}
        let obj5 = {}

        if (this.formData.workSummaryList.length > 0) {
          for (let i = 0; i < this.formData.workSummaryList.length; i++) {
            if (i == 0) {
              obj1.importantTaskId = this.formData.workSummaryList[i].importantTaskId
            }
            if (i == 1) {
              obj2.importantTaskId = this.formData.workSummaryList[i].importantTaskId
            }
            if (i == 2) {
              obj3.importantTaskId = this.formData.workSummaryList[i].importantTaskId
            }
            if (i == 3) {
              obj4.importantTaskId = this.formData.workSummaryList[i].importantTaskId
            }
            if (i == 4) {
              obj5.importantTaskId = this.formData.workSummaryList[i].importantTaskId
            }
          }
        }

        obj1.selfAndSuperiorEvaluationList = []
        obj2.selfAndSuperiorEvaluationList = []
        obj3.selfAndSuperiorEvaluationList = []
        obj4.selfAndSuperiorEvaluationList = []
        obj5.selfAndSuperiorEvaluationList = []
        if (this.formData.majorWork1 != '') {
          obj1.importantTask = this.formData.majorWork1
        }
        if (this.formData.evaluateValue1_1) {
          obj1.selfAndSuperiorEvaluationList.push({
            finishExpect: 1,
            selfEvaluation: this.formData.evaluateValue1_1
          })
        }
        if (this.formData.evaluateValue1_2) {
          if (this.formData.evaluateValue1_1 == '') {
            obj1.selfAndSuperiorEvaluationList.push(null)
          }
          obj1.selfAndSuperiorEvaluationList.push({
            finishExpect: 2,
            selfEvaluation: this.formData.evaluateValue1_2
          })
        }
        if (this.formData.evaluateValue1_3) {
          if (this.formData.evaluateValue1_1 == '') {
            obj1.selfAndSuperiorEvaluationList.push(null)
          }
          if (this.formData.evaluateValue1_2 == '') {
            obj1.selfAndSuperiorEvaluationList.push(null)
          }
          obj1.selfAndSuperiorEvaluationList.push({
            finishExpect: 3,
            selfEvaluation: this.formData.evaluateValue1_3
          })
        }
        if (this.formData.evaluateValue1_4) {
          if (this.formData.evaluateValue1_1 == '') {
            obj1.selfAndSuperiorEvaluationList.push(null)
          }
          if (this.formData.evaluateValue1_2 == '') {
            obj1.selfAndSuperiorEvaluationList.push(null)
          }
          if (this.formData.evaluateValue1_3 == '') {
            obj1.selfAndSuperiorEvaluationList.push(null)
          }
          obj1.selfAndSuperiorEvaluationList.push({
            finishExpect: 4,
            selfEvaluation: this.formData.evaluateValue1_4
          })
        }
        if (this.formData.evaluateValue1_5) {
          if (this.formData.evaluateValue1_1 == '') {
            obj1.selfAndSuperiorEvaluationList.push(null)
          }
          if (this.formData.evaluateValue1_2 == '') {
            obj1.selfAndSuperiorEvaluationList.push(null)
          }
          if (this.formData.evaluateValue1_3 == '') {
            obj1.selfAndSuperiorEvaluationList.push(null)
          }
          if (this.formData.evaluateValue1_4 == '') {
            obj1.selfAndSuperiorEvaluationList.push(null)
          }
          obj1.selfAndSuperiorEvaluationList.push({
            finishExpect: 5,
            selfEvaluation: this.formData.evaluateValue1_5
          })
        }
        arr.push(obj1)
        console.log(arr)
        // importantTask":"1","selfAndSuperiorEvaluationList":[]
        // {"importantTaskId":1159,"importantTask":"1","selfAndSuperiorEvaluationList":[{"finishExpect":1,"selfEvaluation":1}]}
        // "selfAndSuperiorEvaluationList":[{"id":5382,"finishExpect":1,"selfEvaluation":1},null,{"finishExpect":3,"selfEvaluation":5}]

        let params = {
          id: this.id ? this.id : '',
          staffId: this.staffId,
          orgDepartmentId: this.formData.orgDepartmentId,
          orgJobId: this.formData.orgJobId,
          orgLeaderId: this.formData.orgLeaderId,
          changeJobExperience: this.formData.changeJobExperience,
          state: this.state,
          nowAdvantage: this.formData.nowAdvantage,
          promote: this.formData.promote,
          actionPlanForPromote: this.formData.actionPlanForPromote,
          improvement: this.formData.improvement,
          improvementGoal: this.formData.improvementGoal,
          actionPlanForImprovement: this.formData.actionPlanForImprovement,
          personalShortCareerInterest: this.formData.personalShortCareerInterest,
          personalLongCareerInterest: this.formData.personalLongCareerInterest,
          flexibilityWorkplace: this.formData.flexibilityWorkplace,
        }

        params.workSummaryList = JSON.stringify(arr)
        // console.log(params)

        this.$post(`saveEmpAssessmentForm`, params).then(
          res => {
            if (res && res.errCode === 0) {
              console.log(res)
              this.getEmpAssessmentForm()
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 提交
      onSubmit() {
        console.log(this.formData)
        if (!this.formData.orgDepartmentId) {
          this.$message({
            type: 'warning',
            message: '请选择部门'
          })
          return
        }
        if (!this.formData.orgJobId) {
          this.$message({
            type: 'warning',
            message: '请选择职务'
          })
          return
        }
        if (!this.formData.orgLeaderId) {
          this.$message({
            type: 'warning',
            message: '请选择直接主管'
          })
          return
        }
        
        if (!this.formData.changeJobExperience) {
          this.$message({
            type: 'warning',
            message: '请输入换岗经历'
          })
          return
        }
        if (!this.formData.nowAdvantage || !this.formData.promote || !this.formData.actionPlanForPromote || !this
          .formData.improvement || !this.formData.improvementGoal || !this.formData.actionPlanForImprovement) {
          this.$message({
            type: 'warning',
            message: '请输入改进及发展计划下全部内容'
          })
          return
        }
        if (!this.formData.personalShortCareerInterest || !this.formData.personalLongCareerInterest || !this.formData
          .flexibilityWorkplace) {
          this.$message({
            type: 'warning',
            message: '请输入职业发展兴趣下全部内容'
          })
          return
        }

      }

    },
    mounted() {
      this.getSectionOptions()
      this.getEvaluateOptions()
      this.getEmpAssessmentForm()
    }
  }
</script>
<style lang="scss">
  #aaa {
    padding: 0 100px;

    .personInfoBox {
      padding-bottom: 30px;
      // border-bottom: 2px solid #d8d8d8;
    }

    .el-collapse {
      border-bottom: none !important;
    }

    .el-collapse .el-collapse-item__header {
      font-size: 20px !important;
      margin: 10px 0 !important;
      border-bottom: none !important;
      font-weight: bold;
    }

    .el-collapse .el-collapse-item__wrap {
      font-size: 20px !important;
      border-bottom: none !important;
    }

    .el-collapse .el-collapse-item__content {
      font-size: 16px;
      font-weight: bold;
    }

    .topBox {
      // flex: 1;
      width: 33%;
      display: inline-block;
    }

    .evaluateBox {
      width: 50%;
      margin: 15px 0;
    }

    .evaluateBox span.w-100 {
      display: inline-block;
      width: 100px;

    }

    .evaluateBox .el-select {
      width: 70% !important;
    }

    .mr10 {
      margin-right: 10px;
    }

    .topBox .el-select {
      width: 70% !important;
    }

    .mtb10 {
      margin: 10px 0 5px;
    }

    // .el-textarea__inner {
    //   width: 94%;
    // }

    .textareaBox {
      // width: 97%;
      margin-bottom: 30px;
    }

    .textareaBox3 {
      width: 30%;
      margin-right: 3%;
      display: inline-block;
    }

    .textareaBox2 {
      width: 45%;
      margin-right: 3%;
      display: inline-block;
    }

    .textareaBox1 {
      // width: 103%!important;
      display: inline-block;
    }

    .c-676a6c {
      font-weight: bold;
      color: #676a6c !important;
    }

    .el-tabs__nav-wrap {
      position: absolute !important;
      ;
    }

    .manage .el-tabs {
      background-color: #fff;
    }

    .el-tabs__content {
      background-color: #fff;
      padding-top: 50px;
      padding-bottom: 30px;
    }

    .el-tabs__item {
      padding: 0 70px;
    }

    .tabs__item.is-top:nth-child(2) {
      padding-left: 70px;
    }

    .tabs__item.is-top:last-child {
      padding-right: 70px;
    }

    .el-tab-pane {
      width: 75%;
    }
  }
</style>